<template>
  <stepper-layout
    :stepTitle="'Payment Options'"
    :stepIcon="'payment'"
  >
    <v-layout column>
      <credit-card class="pr-3" />
      <v-flex class="text-h6 mt-3">Payment Notes</v-flex>
      <div class="mt-2">{{ paymentNotes.value }}</div>
      <v-flex class="text-h6 mt-4">Automatic Payments</v-flex>
      <v-radio-group
        row
        v-model="automaticPayments"
        class="pt-2 mt-1"
        :disabled="!recording"
      >
        <v-radio
          data-testid="rent-autobill-enroll-radio"
          class="rent-autobill-enroll-radio"
          label="Enroll in Automatic Payments"
          value="1"
        />
        <v-radio
          data-testid="rent-autobill-decline-radio"
          class="rent-autobill-decline-radio"
          label="Decline Automatic Payments"
          value="2"
        />
      </v-radio-group>
    </v-layout>
  </stepper-layout>
</template>

<script>
import CreditCard from "@/components/CreditCard";
import StepperLayout from "@/layouts/StepperLayout";
import { mapState } from "vuex";

export default {
  props: {
    updateNeeded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      creditCard: state => state.tenant.creditCard,
      options: state => state.tenant.options,
      recording: state => state.call.recording,
      paymentNotes: state => state.settings.settings
        .find(setting => setting.label === "Move In Payment Notes")
    }),
    automaticPayments: {
      get() {
        return this.$store.state.tenant.options.automaticPayments;
      },
      set(newVal) {
        this.$store.commit("setAutomaticPayments", newVal);
      }
    }
  },
  components: {
    StepperLayout,
    CreditCard
  }
};
</script>
